import React from 'react';
import { Text, View } from '@react-pdf/renderer';

const SubSection = ({ text, order, subText }: any) => {
  return (
    <View style={{
      marginTop: 20
    }}>
      <Text style={{
        textAlign: 'justify',
        fontFamily: 'Helvetica-Bold',
        color: 'rgb(147 51 234)'
      }}>Séquence {order + 1} - {text}</Text>
      {
        subText
        ? <Text style={{
          marginTop: 5,
          color: 'rgb(107 114 128)',
        }}>Objectif(s) : {subText}</Text>
        : null
      }
    </View>
  )
}

export default SubSection
